module.exports = __webpack_public_path__ + "img/caas1m.cf7079b2.jpg";